module.exports = __webpack_public_path__ + "img/character_on.47697e5d.png";